import { render, staticRenderFns } from "./Corridor_a_1_2.vue?vue&type=template&id=7b228e58&scoped=true&"
import script from "./Corridor_a_1_2.vue?vue&type=script&lang=js&"
export * from "./Corridor_a_1_2.vue?vue&type=script&lang=js&"
import style0 from "./Corridor_a_1_2.vue?vue&type=style&index=0&id=7b228e58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b228e58",
  null
  
)

export default component.exports